import Header from '@components/Header';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store';
import WapperDrawer from './WapperDrawer';
// import WapperNotification from './WapperNotification';
import StatusOrder from '@pages/OrganizedSales/CreateOrders/layoutContent/StatusOrder';
import UpdateOrderModal from '@pages/OrganizedSales/OrderManager/modifyOrder/UpdateOrderModal';
import { changeOpenUpdateOrder, updateOrderSelected } from '@slice/orderManager.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import TicketCreateModal from '@pages/CSKHManagment/TickerManager/demo/TicketCreateModal';
import { updateOpenCreateTicket } from '@slice/select.slice';
import WapperNotification from './NotifyFirebase/WapperNotification';

type Props = {
  children?: any;
  style?: React.CSSProperties;
  className?: string;
  path?: { name: string; url?: string }[];
  noBackground?: boolean;
};

export function PageLayout({ path, noBackground = false, ...props }: Props) {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const selectedTheme = useSelector((state: RootState) => state.select.themeSelected);
  const openUpdateOrder = useSelector((state: RootState) => state.orderManager.openUpdateOrder);

  const openCreateTicket = useSelector((state: RootState) => state.select.openCreateTicket);

  let prefix;

  if (path) {
    prefix = (
      <WapperBreadcrumb theme={selectedTheme}>
        <Breadcrumb.Item key="/">
          <Link to="/">Trang chủ</Link>
        </Breadcrumb.Item>
        {path.map(x => (
          <Breadcrumb.Item key={x.name}>{x.url ? <Link to={x.url}>{x.name}</Link> : x.name}</Breadcrumb.Item>
        ))}
      </WapperBreadcrumb>
    );
  }

  const callBackClose = () => {
    dispatch(changeOpenUpdateOrder(false));
    dispatch(updateOrderSelected(null));
  };

  return (
    // <div className="relative">
    //   <Header prefix={prefix} theme={selectedTheme} />
    //   <ThemWrapper theme={selectedTheme} {...props} />
    //   <WapperNotification />
    //   <>
    //     <WapperDrawer>
    //       <StatusOrder isQAction={true} />
    //     </WapperDrawer>
    //   </>

    //   {openUpdateOrder && (
    //     <UpdateOrderModal isOpen={openUpdateOrder} callBackClose={callBackClose} type="quanlydonhang" />
    //   )}
    // </div>
    <div className="relative">
      {/* Bọc Header bằng div có z-index cao (ví dụ: z-50) để luôn nổi lên trên */}
      <div className="relative z-50">
        <Header prefix={prefix} theme={selectedTheme} />
      </div>

      <ThemWrapper theme={selectedTheme} {...props} />

      {/* Nếu WapperNotification có z-index bên trong,
          hãy đảm bảo bọc nó bằng z-index thấp hơn (ví dụ: z-40) hoặc để nguyên nếu z-50 đã đủ cao */}
      <div className="relative z-40">
        <WapperNotification />
      </div>

      <>
        <WapperDrawer>
          <StatusOrder isQAction={true} />
        </WapperDrawer>
      </>

      {openUpdateOrder && (
        <UpdateOrderModal isOpen={openUpdateOrder} callBackClose={callBackClose} type="quanlydonhang" />
      )}

      {openCreateTicket && (
        <TicketCreateModal isOpen={openCreateTicket} callBackClose={() => dispatch(updateOpenCreateTicket(false))} />
      )}
    </div>
  );
}

const WapperBreadcrumb = styled(Breadcrumb)<{ theme?: any }>`
  background-color: ${({ theme }) => theme.colors!.background};
  color: ${({ theme }) => theme.colors!.text + '!important'};
`;

// layout này cần set đúng kích thước khi dùng
const Layout = styled.div`
  z-index: 1;
  padding: 5px;
  min-height: calc(100vh - 85px);
  max-height: 100%;
`;

const ThemWrapper = styled(Layout)<{ theme?: any }>``;

PageLayout.displayName = 'Layout';

export default PageLayout;
